import { workplaceTypes } from "../types";
import { isEnabledMsg, isUnreadMsg } from "@/utils.js";
import { HeaderMenuBlock } from "../Block/HeaderMenuBlock/HeaderMenuBlock";
import { appNotification } from '@/components/AppNotification.js'
import { storage } from "@/components/Storage";
import { user } from "@/components/User";
import { interval } from '@/components/Interval.js';
import { loader } from '@/components/Loader.js';
import { server } from '@/components/Server.js';


export var SelectWorkplacePage = {
    controller: function () {
        var self = this;

        if (!user.exists()) {
            m.route('/login');
            return;
        }

        interval.clearAll();

        loader.show();

        var setUserWorkplace = function (id) {
            var data = {workplaceId: parseInt(id)};

            m.request({
                method: 'POST',
                url: '/api/workplace',
                data: data
            }).then(function (response) {
                server.setOnline();
                loader.hide();
                storage.config = response.config;
                user.set('state.workplace', data.workplaceId);

                // при смене рабочего места очищаем данные по выбранному транспорту
                if (user.has('state.vehicle')) {
                    user.remove('state.vehicle');
                }
                if (user.has('state.vehicleType')) {
                    user.remove('state.vehicleType');
                }
                if (user.has('state.vehicleNumber')) {
                    user.remove('state.vehicleNumber');
                }

                if (data.workplaceId === workplaceTypes.driver) {
                    m.route('/vehicle');
                } else if (data.workplaceId === workplaceTypes.security) {
                    m.route('/security/flights');
                } else if (data.workplaceId === workplaceTypes.agent) {
                    m.route('/agent/tasks');
                } else if (data.workplaceId === workplaceTypes.conveyer) {
                    m.route('/conveyer');
                } else {
                    m.route('/');
                }
                if (appNotification.available()) {
                  appNotification.load(true)
                }
            }, function (response) {
                if (response && response.message) {
                    self.errmsg = (m(".alert.alert-danger", response.message));
                } else {
                    server.setOffline();
                }
                loader.hide();
            });
        };

        this.workplaces = [
            {
                id: workplaceTypes.supervisor,
                icon: 'supervisor',
                title: 'Супервайзер'
            },
            {
                id: workplaceTypes.executor,
                icon: 'executor',
                title: 'Исполнитель'
            },
            {
                id: workplaceTypes.driver,
                icon: 'driver',
                title: 'Водитель'
            },
            {
                id: workplaceTypes.agent,
                icon: 'agent',
                title: 'Агент СОП'
            },
            {
                id: workplaceTypes.security,
                icon: 'security',
                title: 'Сотрудник САБ'
            },
            {
                id: workplaceTypes.conveyer,
                icon: 'bag',
                title: 'Грузчик багажа'
            }
        ].filter(function (value) {
            let arr = Object.values(user.get('workplaces'));
            for(let i = 0; i < arr.length; i++) {
                if(arr[i] == value.id)
                    return true;
            }
            return false;
        });

        this.data = m.request({
            method: 'GET',
            url: '/api/workplace'
        }).then(function (response) {
            server.setOnline();
            loader.hide();
            storage.config = response.config;

            server.initPing();

            if(user.get('workplaces')[0] === 0) {
                swal({
                    text: 'У данного табельного номера нет соответствия ролей',
                    icon: "error",
                    buttons: ["Подтвердить"]
                });
                return response;
            }

            if(user.get('workplaces').length === 1) {
                var workplaceId = parseInt(user.get('workplaces')[0]);
                setUserWorkplace(workplaceId);
                return;
            }

            return response;
        }, function (response) {
            if (response && response.message) {
                self.errmsg = (m(".alert.alert-danger", response.message));
            } else {
                server.setOffline();
            }
            loader.hide();
        });

        this.setUserWorkplace = setUserWorkplace;

        this.topMenu = [
            { title: 'Профиль', url: '/profile', icon: 'fa-user' },
            isEnabledMsg() ? { title: 'Сообщения', url: '/message', icon: isUnreadMsg() ? 'fa-envelope-o' : 'fa-envelope-open-o' } : {},
            { title: 'Выйти', url: '/logout', icon: 'fa-sign-out' },
        ]
    },
    view: function (ctrl) {
        return [
            m.component(HeaderMenuBlock, {
                time: {},
                menu: ctrl.topMenu
            }),
            ctrl.errmsg,
            m(".container[style='margin: 15px 0']", [
                ctrl.workplaces.map(function (place) {
                    return m(".media.workPlaceType", {
                        onclick: ctrl.setUserWorkplace.bind(null, place.id)
                    }, [
                        m(".media-left", [
                            m("img.media-object.img-circle[style='height:70px;width:70px']", {
                                src: "/img/" + place.icon + "-icon.png"
                            })
                        ]),
                        m(".media-body", [
                            m("h4.media-heading", place.title)
                        ])
                    ])
                })
            ])
        ];
    }
};
